import CardSkeleton from './CardSkeleton';

export default CardSkeleton;

export type { CardSkeletonShape, ICardSkeletonProps } from './CardSkeleton';
